export default __webpack_public_path__ + "static/media/japp&go-logo.7494e38f.svg";